export const ALERT_NOTIFICATIONS_CONTAINER_ID = 'dashboard-alert-notifications';
